var render = function render(){var _vm=this,_c=_vm._self._c;return _c('uw-content',{attrs:{"title":"出勤看板"}},[_c('div',{staticClass:"w-checkin-content"},[_c('div',{staticClass:"w-checkin-map",attrs:{"id":"BaiduMap"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }